const HTTP_NOT_FOUND = 404;
const API_ENDPOINT_NOT_FOUND_CODE = "ApiEndpointNotFound";

/** The primary entry loader owns this check; dependent resources must not redirect its page. */
export function isMissingEntryError(error: unknown): boolean {
  if (!(error instanceof Error) || !("status" in error) || error.status !== HTTP_NOT_FOUND) return false;
  return !("code" in error) || error.code !== API_ENDPOINT_NOT_FOUND_CODE;
}
